import React from "react";
import { i18, trb } from "../../../Utilities";

export const RemoveOwnerComp = ({ id, onRemoveClick }) => {
  return (
    <a className="add ml-3" onClick={() => onRemoveClick(id)}>
      {trb(i18.ApplicationsLabels.Remove)}
    </a>
  );
};
